module.exports = __webpack_public_path__ + "img/587w.ff7aee6.jpg";